// https://github.com/maxmantz/redux-oidc/issues/58import { withRouter } from "react-router-dom";

import React, { useEffect, useState } from "react";
import getUserManager from "./user-manager";
import Localized from "../components//localized";
import { Spinner } from "../components//state-indicators";
import { useHref, useLocation } from "react-router-dom";
const CheckAuth = props => {
    const [isValidUser, setIsValidUser] = useState(false);
    const location = useLocation();
    const base = useHref("/");

    useEffect(() => {
        if (props.anonymousMode) return;
        const { pathname } = location || {};
        if (pathname !== "/authentication/callback" && pathname !== "/authentication/signoutCallback" && pathname !== "/login") {
            const userManager = getUserManager();
            userManager.getUser().then(response => {
                if (!response || response.expired) {
                    let redirectUrl = window.location.pathname + window.location.search;
                    if (redirectUrl.startsWith(base)) redirectUrl = redirectUrl.replace(base, "/");
                    userManager.signinRedirect({ state: { redirectUrl } }).catch(() => setIsValidUser(true));
                } else {
                    setIsValidUser(true);
                }
            });
        } else {
            setIsValidUser(true);
        }
    }, []); // eslint-disable-line
    if (props.anonymousMode) return props.children;

    if (!isValidUser) {
        return (
            <div style={{ position: "relative", height: "100vh", width: "100vw" }}>
                <Localized>
                    <Spinner withCaption fillParent={true} />
                </Localized>
            </div>
        );
    } else {
        return props.children;
    }
};

export default CheckAuth;
